import { useEffect, useState , useContext } from "react"
import './Releases.scss'
import {
  Link
} from "react-router-dom";
import Cookies from "universal-cookie";
import ProgressBar from "../ProgressBar/ProgressBar";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { captureException } from '@sentry/browser';
import Button from '../Button/Button'
import Modal from "../Modal/Modal";
import { Redirect } from "react-router-dom";
import PermissionsGate from '../PermissionsGate/PermissionsGate'
import {SCOPES} from '../PermissionsGate/permissionMaps'
export default function Releases() { 

  const cookies = new Cookies();

    const[frontend_last_release_pr,set_frontend_last_release_pr] = useState(null);
    const[backend_last_release_pr,set_backend_last_release_pr] = useState(null);
    const[frontend_new_release_pr,set_frontend_new_release_pr] = useState(null);
    const[backend_new_release_pr,set_backend_new_release_pr] = useState(null);
    const[last_tag,set_last_tag] = useState(null);
    const[new_tag,set_new_tag] = useState(null);
    const [open_lock_dialog, set_open_lock_dialog] = useState(false);
    const[open_unlock_dialog,set_open_unlock_dialog] = useState(false);
    const [open_branch_lock_dialog, set_open_branch_lock_dialog] = useState(false);
    const[open_branch_unlock_dialog,set_open_branch_unlock_dialog] = useState(false)
    const [reason , set_reason] = useState("")
    const [train_status,set_train_status]=useState("Not blocked")
    const [lock_branches,set_lock_branches] = useState("")
    const [branch_to_lock,set_branch_to_lock] = useState()
  
    const handle_lock_dialog_close = () => {
      set_open_lock_dialog(false);
      set_open_branch_lock_dialog(false);
    };
  
    const handle_unlock_dialog_close = () => {
      set_open_unlock_dialog(false);
      set_open_branch_unlock_dialog(false);
      set_reason("")
    };

    const close_all_dialogs = () => {
      set_open_unlock_dialog(false);
      set_open_branch_unlock_dialog(false);
      set_open_lock_dialog(false);
      set_open_branch_lock_dialog(false);
    }

    useEffect ( () => {
      console.log("useEffect")
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "code": cookies.get("code")
        })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_lock_branch/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          set_lock_branches(data)
        }
        catch(error) {
          const event_id = captureException(error);
        }

   });
    },[open_branch_unlock_dialog,open_branch_lock_dialog,])

    useEffect( () => {
        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "code": cookies.get("code")
        })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_last_release_pr/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        const res = data;
       set_frontend_last_release_pr(res.frontend.prs.filter(pr => ! pr.message.includes("Empty commit from")))
       set_backend_last_release_pr(res.backend.prs.filter(pr => ! pr.message.includes("Empty commit from")))
      }
      catch (error){
        const event_id = captureException(error);
        console.log('error logged', { event_id });
      }

     });

     
    },[])

    useEffect( () => {
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code")
      })
  };
  fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/set_last_release_pr/" , options).then(response=>response.json())
  .then(async data=>{ 
    try{
      const res = data;
     set_frontend_last_release_pr(res.frontend.prs.filter(pr => ! pr.message.includes("Empty commit from")))
     set_backend_last_release_pr(res.backend.prs.filter(pr => ! pr.message.includes("Empty commit from")))
    }
    catch (error){
      captureException(error);
      cookies.remove("code");
      return <Redirect to="/login" />;
    }

   });

   
  },[])

    useEffect ( () => {
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code")
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_new_release_pr/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        const res = data
        set_frontend_new_release_pr(res.frontend.prs)
        set_backend_new_release_pr(res.backend.prs)
        set_last_tag(res.backend.last_tag);
        set_new_tag(res.backend.new_tag);
        if(res.backend.new_tag =="workiz.com"){
          set_new_tag("no release candidate")
        }
        }
        catch(error) {
          captureException(error);
          cookies.remove("code");
          return <Redirect to="/login" />;
        }

   });
    },[])

    useEffect ( () => {
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code")
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/set_new_release_pr/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        const res = data
        set_frontend_new_release_pr(res.frontend.prs)
        set_backend_new_release_pr(res.backend.prs)
        set_last_tag(res.backend.last_tag);
        set_new_tag(res.backend.new_tag);
        if(res.backend.new_tag =="workiz.com"){
          set_new_tag("no release candidate")
        }
        }
        catch(error) {
          const event_id = captureException(error);
          cookies.remove("code");
          return <Redirect to="/login" />;
        }

   });
    },[])

    useEffect ( () => {
      var options = {
        'method': 'GET',
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/releaseProgress/get_train_status/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          set_train_status(data)
        }
        catch(error) {
          const event_id = captureException(error);
          cookies.remove("code");
          return <Redirect to="/login" />;
        }

   });
    },[])

    function update_train_status (){

      var options = {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "status": !train_status.status,
        "reason" : reason
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/releaseProgress/set_train_status/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
       
        }
        catch(error) {
          const event_id = captureException(error);
          console.log('error logged', { event_id });
        }
      });
      set_open_lock_dialog(false)
      set_open_unlock_dialog(false)
      set_reason("")
      set_train_status({"status": !train_status.status , "reason" : reason , "user" : cookies.get("name")})

    }

    function lock_branch (){

      var options = {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "reason" : reason,
        "env": branch_to_lock,
        "lock":  !lock_branches[`${branch_to_lock}_branch`]?.lock , 
        "user" : cookies.get("login")
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/lock_branch/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          set_open_branch_lock_dialog(false)
          set_open_branch_unlock_dialog(false)
       
        }
        catch(error) {
          const event_id = captureException(error);
          console.log('error logged', { event_id });
        }
      });
      
      set_reason("")
    }

    return(
      <PermissionsGate scopes={[SCOPES.canView]} >
      <div className="split right">
        <div className="release_title">
        <div className="release_title1">
          
          <div className="versions">
            <div className="version_title">
              Current version:
              <div className="version">
                {last_tag}
              </div>
            <div className="line"/>
            </div>
            <div className="version_title">
              Next version:
              <div className="version">
                {new_tag}
              </div>
            </div>
            
          </div>
          
          <div className="locks">

          <div className="block_train">
              {!train_status.status ? (
                <div>
                  <Button text="Block train" startIcon={<LockOpenIcon/>} onClick={()=>set_open_lock_dialog(true)} className="block_train_button" Tooltip="Bock train"/>
                </div>
              ):(
                <div >
                   <div>
                <Button text="Unblock train" startIcon={<LockIcon/>} onClick={()=>set_open_unlock_dialog(true)} className="block_train_button lock" Tooltip="Unbock train"/>
                </div>
                  <div className="train_lock_reason">
                  locked by {train_status.user}. lock reason - {train_status.reason}
                  </div>
                </div>
              )}
          </div>

          <div className="block_train">
              {!lock_branches["workiz.com_branch"]?.lock ? (
                <div>
                  <Button text="Lock workiz.com" startIcon={<LockOpenIcon/>} onClick={()=>{set_open_branch_lock_dialog(true); set_branch_to_lock("workiz.com")}} className="block_train_button" Tooltip="Lock workiz.com branch in backend and frontend"/>
                </div>
              ):(
                <div >
                <Button text="Unlock workiz.com" startIcon={<LockIcon/>} onClick={()=>{set_open_branch_unlock_dialog(true); set_branch_to_lock("workiz.com")}} className="block_train_button lock" Tooltip="Unlock workiz.com branch in backend and frontend"/>
                  <div className="train_lock_reason">
                  locked by {lock_branches["workiz.com_branch"].user}. lock reason - {lock_branches["workiz.com_branch"].reason}
                  </div>
                </div>
              )}
          </div>

          <div className="block_train">
              {!lock_branches["rc_branch"]?.lock ? (
                <div>
                  <Button text="Lock rc" startIcon={<LockOpenIcon/>} onClick={()=>{set_open_branch_lock_dialog(true); set_branch_to_lock("rc")}} className="block_train_button" Tooltip="Lock rc branch in backend and frontend"/>
                </div>
              ):(
                <div >
                   <div>
                <Button text="Unlock rc" startIcon={<LockIcon/>} onClick={()=>{set_open_branch_unlock_dialog(true); set_branch_to_lock("rc")}} className="block_train_button lock" Tooltip="Unlock rc branch in backend and frontend"/>
                </div>
                  <div className="train_lock_reason">
                  locked by {!lock_branches["rc_branch"].user}. lock reason - {!lock_branches["rc_branch"].reason}
                  </div>
                </div>
              )}
          </div>

          </div>
          </div>
          
          <ProgressBar/>
        </div>
        
        <div className="release_prs">
          <div className="release_container">
            <div className="last_release">
              <div className="title">
              Last release:
              </div>
              <div className="prs">
                Frontend:
                {frontend_last_release_pr && 
                  frontend_last_release_pr.map((pr,index) => <div className="pr"  key={index}> <img  className="avatar" src={pr.avatat_url} alt="new" /> {pr.author} - <Link to ={{pathname:`${pr.url}`}} target="_blank"> {pr.message}</Link></div>)
                }
              </div>
              <div  className="prs">
              Backend:
              {backend_last_release_pr && 
                  backend_last_release_pr.map((pr,index) => <div className="pr" key={index}> <img  className="avatar" src={pr.avatat_url} alt="new" /> {pr.author} - <Link to ={{pathname:`${pr.url}`}} target="_blank"> {pr.message}</Link></div>)
                }
              </div>
            </div>
            <div className="line" style={{"height": "100%"}}/>
            <div className="going_to_release">
              <div className="title">
                Going to be release:
              </div>
              <div className="prs">
                Frontend:
                {frontend_new_release_pr && 
                  frontend_new_release_pr.map((pr,index) => <div className="pr"  key={index}> <img  className="avatar" src={pr.avatat_url} alt="new" /> {pr.author} - <Link to ={{pathname:`${pr.url}`}} target="_blank"> {pr.message}</Link></div>)
                }
              </div>
              <div  className="prs">
                Backend:
                {backend_new_release_pr && 
                  backend_new_release_pr.map((pr,index) => <div className="pr"  key={index}> <img  className="avatar" src={pr.avatat_url} alt="new" /> {pr.author} - <Link to ={{pathname:`${pr.url}`}} target="_blank"> {pr.message}</Link></div>)
                }
              </div>

            </div>
          </div>
        </div>

        <PermissionsGate scopes={[SCOPES.canView]} >
        <Modal open={open_lock_dialog ||open_unlock_dialog ||open_branch_lock_dialog || open_branch_unlock_dialog} onClose={()=>close_all_dialogs()} 
          title={"You have no permission to lock or unlock"}
        />
        </PermissionsGate>
        <PermissionsGate scopes={[SCOPES.canDelete]} >
        <Modal open={open_lock_dialog} onClose={()=>set_open_lock_dialog(false)} 
          title={"Lock train"}
          text={"To lock train, please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_lock_dialog_close() },
                    {"text":"Lock" ,  "class": "modalOK" , "onClick" : ()=>update_train_status() ,"disabled": !reason.length }
                  ]}
        />

        <Modal open={open_unlock_dialog} onClose={()=>set_open_unlock_dialog(false)} 
          title={"Unlock train"}
          text={"To Unlock train, please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_unlock_dialog_close() },
                    {"text":"Unlock" ,  "class": "modalOK" , "onClick" : ()=>update_train_status() ,"disabled": !reason.length }
                  ]}
        />


        <Modal open={open_branch_lock_dialog} onClose={()=>set_open_branch_lock_dialog(false)} 
          title={`Lock ${branch_to_lock} branch`}
          text={"To lock train, please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_lock_dialog_close() },
                    {"text":"Lock" ,  "class": "modalOK" , "onClick" : ()=>lock_branch() ,"disabled": !reason.length }
                  ]}
        />

        <Modal open={open_branch_unlock_dialog} onClose={()=>set_open_branch_unlock_dialog(false)} 
          title={`Unock ${branch_to_lock} branch`}
          text={"To Unlock train, please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_unlock_dialog_close() },
                    {"text":"Unlock" ,  "class": "modalOK" , "onClick" : ()=>lock_branch() ,"disabled": !reason.length }
                  ]}
        />

        </PermissionsGate>
      </div>
      
      </PermissionsGate>
      )
}